@if (icon) {
  <div class="button-wrapper">
    <div [attr.data-busy]="loading || null"
         class="loading-container">
      <button (click)="handleClick()"
              [color]="color"
              [disabled]="disabled || loading"
              [hidden]="hidden"
              [value]="title! | translate"
              mat-icon-button>
        <mat-icon [ngClass]="class"
                  title="{{title}}">{{ icon }}
        </mat-icon>
      </button>
      @if (loading) {
        <span class="dots-loading">
        <i></i><i></i><i></i>
      </span>
      }
    </div>
  </div>
} @else {
  @if (!Image) {
    <div class="button-wrapper">
      <div [attr.data-busy]="loading || null"
           [hidden]="hidden"
           class="loading-container">
        <div (click)="handleClick()"
             [style.pointer-events]="(disabled || loading) ? 'none' : 'auto'"
             class="border-0"
             style="cursor: pointer;">
          <input [disabled]="disabled || loading"
                 [ngClass]="class"
                 [value]="title! | translate"
                 class="card styled"
                 type="button"/>
        </div>
        @if (loading) {
          <span class="dots-loading">
          <i></i><i></i><i></i>
        </span>
        }
      </div>
    </div>
  } @else {
    <section class="btn-new">
      <div (click)="handleClick()"
           [attr.data-busy]="loading || null"
           [ngClass]="class"
           [style.pointer-events]="(disabled || loading) ? 'none' : 'auto'"
           class="d-flex align-items-center loading-container"
           style="cursor: pointer;">
        <img [src]="src"/>
        <input [disabled]="disabled || loading"
               [value]="title! | translate"
               class="card styled"
               type="button"/>
        @if (loading) {
          <span class="dots-loading">
          <i></i><i></i><i></i>
        </span>
        }
      </div>
    </section>
  }
}
